import {
  OptionManualFour,
  OptionManualThree,
  Result,
  ResultQuestionFour,
  ResultQuestionManualOne,
  ResultQuestionManualTwo,
  ResultQuestionThree,
} from '../types/questionManuals';

export function convertDataForQuestionManualOne(
  input: ResultQuestionManualOne[],
) {
  return input.reduce((acc: Result[], item) => {
    const firstChar =
      (item?.description && item.description.charAt(0).toUpperCase()) || '';
    const existingOption: Result | undefined = acc.find(
      (entry) => entry.key === firstChar,
    );

    if (existingOption) {
      existingOption.option.push({
        makeCode: item.makecode || '',
        description: item.description || '',
        vehicletype: item.vehicletypes,
      });
    } else {
      acc.push({
        key: firstChar,
        option: [
          {
            makeCode: item.makecode || '',
            description: item.description || '',
            vehicletype: item.vehicletypes,
          },
        ],
      });
    }

    return acc;
  }, []);
}

export function convertDataForQuestionManualTwo(
  input: ResultQuestionManualTwo[],
) {
  return input.reduce((acc: Result[], item) => {
    const firstChar = item.description.charAt(0).toUpperCase();
    const existingOption: Result | undefined = acc.find(
      (entry) => entry.key === firstChar,
    );

    if (existingOption) {
      existingOption.option.push({
        makeCode: item.makecode,
        description: item.description,
        vehicletype: item.vehicletype,
        familyCode: item.familycode,
      });
    } else {
      acc.push({
        key: firstChar,
        option: [
          {
            makeCode: item.makecode,
            description: item.description,
            vehicletype: item.vehicletype,
            familyCode: item.familycode,
          },
        ],
      });
    }

    return acc;
  }, []);
}
export function convertDataForQuestionManualThree(
  input: ResultQuestionThree[],
): OptionManualThree[] {
  const uniqueYears = new Set<string>();
  const result: OptionManualThree[] = [];

  input.forEach((item) => {
    if (!uniqueYears.has(item.year)) {
      uniqueYears.add(item.year);
      result.push({
        year: item.year,
        description: item.description,
        makeCode: item.makecode,
        vehicletype: item.vehicletype,
        month: item.month,
        familyCode: item.familycode,
      });
    }
  });

  return result;
}

export function convertDataForQuestionManualFour(
  input: ResultQuestionFour[],
): OptionManualFour[] {
  const uniqueItem = new Set<string>();
  const result: OptionManualFour[] = [];

  input.forEach((item) => {
    if (!uniqueItem.has(item.description)) {
      uniqueItem.add(item.description);
      result.push({
        description: item.description,
        makecode: item.makecode || item.makeCode,
        familycode: item.familycode || item.familyCode,
        family: item.family || '',
        vehicletypes: item.vehicletypes || 'PS, LC',
        year: item.year,
        month: item.month,
        rbc: item.rbc,
        make: item?.make || '',
      });
    }
  });

  return result;
}
